module.exports = __webpack_public_path__ + "static/media/exam.8632b353.svg";